import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import * as C from '../../../theme/colors.constants';

/**
 * `LinkAdicionar` — link "Adicionar X +" reutilizado por todas as listas
 * reais do módulo (Endereço/Telefone/E-mail, Devedor e Cliente).
 *
 * `BlocoEnderecos`/`BlocoTelefones` (mocks estáticos que existiam aqui até
 * a AW2-1136 Etapa 2) foram removidos — `AbaCliente.jsx`, o último
 * consumidor, passou a usar `EnderecoCliente.jsx`/`TelefoneCliente.jsx`
 * reais; `AbaDevedor.jsx` já não os usava desde a AW2-1134 Etapa 3/4.
 *
 * `onClick`/`disabled` opcionais (AW2-1134 Etapa 3) — sempre passados pelos
 * consumidores reais atuais (nenhum mock estático resta usando o default
 * silencioso). Quando `disabled`, some o cursor/hover de clicável — mesmo
 * padrão de "prop opcional com default preservando o outro consumidor" já
 * usado no módulo (`hideBackdrop`, `DialogSelecionarAntecedentes.jsx`).
 */
export function LinkAdicionar({ children, onClick, disabled }) {
  return (
    <Typography
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      sx={{
        color: disabled ? C.warmGrey : C.navy,
        fontWeight: 700,
        cursor: disabled ? 'default' : 'pointer',
        mt: 2,
        mb: 1,
        fontSize: 'clamp(13px, 0.78vw, 18px)',
        ...(disabled ? {} : { '&:hover': { textDecoration: 'underline' } }),
      }}
    >
      {children}
    </Typography>
  );
}
LinkAdicionar.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
LinkAdicionar.defaultProps = {
  children: null,
  onClick: () => null,
  disabled: false,
};
